import {
  fetchAddFavorite,
  IAddFavoriteRequest,
  IAddFavoriteResponse,
  TAddFavoriteResponse,
} from '../../repositories/favorites/v1/add-favorite';
import { IApplicationContext } from '../../types/applicationContext';

export async function fetchAddToFavorites(context: IApplicationContext, parameters: IAddFavoriteRequest) {
  const { httpApi, logger } = context;

  try {
    const response: TAddFavoriteResponse = await fetchAddFavorite({
      httpApi,
      parameters,
    });

    return response.response as IAddFavoriteResponse;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
